import { darken } from './colorUtils';
import type { Theme } from './types';

export const resolveChartPlotAreaBackgroundColor = (theme: Theme): string =>
  theme.palette.mode === 'dark'
    ? darken(theme.app.colors.surface, 0.12)
    : theme.app.colors.surfaceAlt;
